import React, { useState, useEffect } from 'react';
import Spiner from '../Components/Admin/Spiner/Spiner';
import { Outlet } from 'react-router-dom';
import Auth from '../Components/Admin/Auth/Auth';
import baseURL from '../Components/url';
import './MainLayout.css';
export default function MainLayout() {
    const [usuario, setUsuario] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${baseURL}/userLogued.php`, {
                    credentials: 'include'
                });
                if (response.ok) {
                    const data = await response.json();
                    if (data && data.idUsuario) {
                        setUsuario(data);
                        localStorage.setItem('usuario', JSON.stringify(data));
                        setLoading(false);
                        return;
                    }
                }
            } catch (error) {
                console.error('Error al obtener datos de sesión:', error);
            }

            // Fallback a localStorage si la cookie cross-origin no pasa
            const localUser = localStorage.getItem('usuario');
            if (localUser) {
                try {
                    setUsuario(JSON.parse(localUser));
                } catch (e) {
                    setUsuario({});
                }
            } else {
                setUsuario({});
            }
            setLoading(false);
        };

        fetchData();
    }, []);

    return (
        <div>
            <div>


                {loading ? (
                    <Spiner />
                ) : usuario.idUsuario ? (
                    <>
                        <Outlet />
                    </>
                ) : (
                    <Auth />
                )}
            </div>

        </div>
    );
}
